import React from "react";
import { useLocation } from "react-router-dom";

const FlashCardExam = () => {
  const { state } = useLocation();

  return <div>FlashCardExam</div>;
};

export default FlashCardExam;
